const VectorTree = ({ className }: { className?: string }) => (
    <svg
        className={className}
        viewBox="0 0 80 100"
        preserveAspectRatio="xMidYMax meet"
    >
        {/* Thân cây */}
        <rect x="35" y="75" width="10" height="25" fill="#8b4513" />
        {/* Các tầng lá */}
        <path d="M40,5 L20,35 L60,35 Z" fill="#22c55e" />
        <path d="M40,25 L15,50 L65,50 Z" fill="#16a34a" />
        <path d="M40,45 L10,70 L70,70 Z" fill="#15803d" />
    </svg>
);

export default VectorTree;
